module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/pagination/prev-d466c39b7d7b02e4c963a7d897bc6e2e.svg";